import React, { useState, useRef } from 'react'
import { CustomImage } from './Image'

interface HoverVideoProps {
  path: string
  videoPath: string
  width?: string
  height?: string
  index: number
  onlyImg?: boolean
}

const HoverVideo: React.FC<HoverVideoProps> = ({
  path,
  videoPath,
  index,
  onlyImg,
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const videoRef = useRef<HTMLVideoElement>(null)

  const handleMouseEnter = () => {
    setIsHovered(true)
    // videoRef.current?.play()
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
    // videoRef.current?.pause()
    // videoRef.current!.currentTime = 0
  }

  return (
    <>
      {onlyImg ? (
        <>
          {' '}
          <CustomImage path={path} width={136} height={240} />
        </>
      ) : (
        <div
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          key={`hover_video_${index}`}
        >
          {isHovered ? (
            <video
              className="rounded-[4px]"
              src={videoPath}
              playsInline
              width={136}
              loop
              autoPlay
              muted
              height={240}
              preload="none"
            />
          ) : (
            <CustomImage path={path} width={136} height={240} />
          )}
        </div>
      )}
    </>
  )
}

export default React.memo(HoverVideo)
